export default "__VITE_ASSET__292b3fea__"